import { useMemo } from 'react'

import { type CrossClientQueryResultDisplay } from '../../../models/CrossClient'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetMeQuery } from '../../../store/user/user'

import { type CrmAction, type CrmActionsMap } from './CrossClientActionsDropdown'
import { CRM_ACTION_REGISTRY, type CrmActionKind } from './crmActionRegistry'
import { useCrmActionHost } from './useCrmActionHost'

export const useCrmActions = (results: CrossClientQueryResultDisplay[]): CrmActionsMap => {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId })
  const { open } = useCrmActionHost()

  return useMemo<CrmActionsMap>(() => {
    const connectedServiceIds = new Set((currentUser?.integrations ?? []).map((integration) => integration.serviceId))

    const map: CrmActionsMap = {}
    for (const [kind, descriptor] of Object.entries(CRM_ACTION_REGISTRY) as [CrmActionKind, (typeof CRM_ACTION_REGISTRY)[CrmActionKind]][]) {
      if (!connectedServiceIds.has(descriptor.serviceId)) continue
      const action: CrmAction = {
        label: descriptor.label,
        icon: descriptor.icon,
        onClick: () => open(kind, { results }),
      }
      const existing = map[descriptor.serviceId] ?? []
      map[descriptor.serviceId] = [...existing, action]
    }
    return map
  }, [results, currentUser?.integrations, open])
}
